import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    client: {
      validations: []
    },
    title: {
      validations: []
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    eventextra3: {
      validations: [
        { type: 'dateinfuture', message: 'Alternative date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please select a theme for your event' }
      ]
    },
    eventextra4: {
      validations: []
    },
    notes: {
      validations: []
    },

  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company:',
            mapping: 'client'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Title:',
            mapping: 'title'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'State:',
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip:',
            mapping: 'postal'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date, first choice:',
            mapping: 'eventDate'
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Alternative Date:',
            mapping: 'eventextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options: [
              { label: 'Group Theater Reservation', value: 'Group Theater Reservation'},
              { label: 'Meeting', value: 'Meeting'},
              { label: 'Banquet', value: 'Banquet'},
              { label: 'Wedding Ceremony, Wedding Rehearsal, Wedding Reception', value: 'Wedding Ceremony, Wedding Rehearsal, Wedding Reception' },
              { label: 'Seminar', value: 'Seminar' },
              { label: 'Retirement', value: 'Retirement' },
              { label: 'Birthday Party', value: 'Birthday Party'},
              { label: 'Office Party', value: 'Office Party'},
              { label: 'Dance/Music Recital', value: 'Dance/Music Recital'},
              { label: 'Memorial', value: 'Memorial'},
              { label: 'MMH Resident Event', value: 'MMH Resident Event'},
              { label: 'MMH Staff Event', value: 'MMH Staff Event'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'theme'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Requested Room (Internal users only):',
            options: [
              { label: 'Evergreen Hall', value: 'Evergreen Hall'},
              { label: 'Evergreen 1', value: 'Evergreen 1'},
              { label: 'Evergreen 2', value: 'Evergreen 2'},
              { label: 'Evergreen 3', value: 'Evergreen 3'},
              { label: 'Evergreen 1 & 2', value: 'Evergreen 1 & 2'},
              { label: 'Evergreen 2 & 3', value: 'Evergreen 2 & 3'},
              { label: 'Dan Patch Hall', value: 'Dan Patch Hall'},
              { label: 'Dan Patch Conference Room', value: 'Dan Patch Conference Room'},
              { label: 'MMHC Board Room', value: 'MMHC Board Room'},
              { label: 'Lodge Room', value: 'Lodge Room'},
              { label: 'Ives Auditorium', value: 'Ives Auditorium'},
              { label: 'Catering Kitchen', value: 'Catering Kitchen'},
              { label: 'Grand Hall', value: 'Grand Hall'},
              { label: 'Meadow/Field', value: 'Meadow/Field'},
              { label: 'Town Square', value: 'Town Square'},
              { label: 'D3 Solarium', value: 'D3 Solarium'},
              { label: 'Wiggin Education Room', value: 'Wiggin Education Room'},
              { label: 'OES Chapel', value: 'OES Chapel'},
              { label: 'Sun Porch', value: 'Sun Porch'},
              { label: 'D3 Activity Room', value: 'D3 Activity Room'},
              { label: 'D1 Community Room', value: 'D1 Community Room'},
              { label: 'Assisted Living Activity Room', value: 'Assisted Living Activity Room'}
            ],
            mapping: 'eventextra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Notes regarding the event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Minnesota Masonic Heritage Center Contact Form',
    formId: '163',
    clientKey: 'C8A1F1DD-9803-4E1F-86BA-58B873B9CC2F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/mnmasonic/form_structure.js